import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, forwardRef, useImperativeHandle, Children, createContext, useCallback, useState, useEffect } from 'react';
import { componentWrapper } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import Step from './step';
import { useSystem, useRefState } from '../_helpers';
export * from './type';
export var StepsContext = /*#__PURE__*/createContext({
  changeIndex: function changeIndex() {}
});
var Steps = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      style = props.style,
      children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'horizontal' : _props$direction,
      _props$iconType = props.iconType,
      iconType = _props$iconType === void 0 ? 'number' : _props$iconType,
      current = props.current,
      _props$defaultIndex = props.defaultIndex,
      defaultIndex = _props$defaultIndex === void 0 ? 0 : _props$defaultIndex,
      _props$status = props.status,
      status = _props$status === void 0 ? 'process' : _props$status,
      items = props.items,
      onClick = props.onClick,
      onChange = props.onChange;

  var _useState = useState(Number(defaultIndex)),
      innerIndex = _useState[0],
      setInnerIndex = _useState[1];

  var _useRefState = useRefState(current === void 0 ? innerIndex : current),
      activeIndex = _useRefState[0],
      activeRefIndex = _useRefState[1],
      setActiveIndex = _useRefState[2];

  var domRef = useRef(null);
  var system = useSystem();

  function changeIndex(newIndex) {
    onClick == null ? void 0 : onClick(newIndex);
    setInnerIndex(newIndex);
    newIndex !== activeRefIndex.current && (onChange == null ? void 0 : onChange(newIndex));
  }

  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current
    };
  });
  useEffect(function () {
    setActiveIndex(current === void 0 ? innerIndex : current);
  }, [current, innerIndex]);
  var renderStep = useCallback(function (child, index) {
    return /*#__PURE__*/React.createElement(StepsContext.Provider, {
      value: {
        iconType: iconType,
        current: activeIndex,
        direction: direction,
        index: index,
        status: activeIndex === index ? status : void 0,
        changeIndex: changeIndex
      },
      key: index
    }, child);
  }, [iconType, activeIndex, direction]);
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-steps " + className + " " + direction + " " + system,
      style: style,
      ref: domRef
    }, items ? items.map(function (item, index) {
      return renderStep( /*#__PURE__*/React.createElement(Step, _extends({}, item, {
        key: index
      })), index);
    }) : Children.toArray(children).map(function (child, index) {
      return renderStep(child, index);
    }));
  });
});
/**
 * 显示一个任务的进度; 或者引导用户完成某个复杂任务。
 * @name 步骤条
 * @type 信息展示
 */

export default componentWrapper(Steps, {
  Step: Step
});